import $ from 'jquery';
const ScrollMagic = require('scrollmagic');
import screenSize from '../services/screen_size';
// require('../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js');
const controller = new ScrollMagic.Controller();
const $window = $(window);
const scenes = [];


function refreshScene({scene, getDuration}) {
    scene.refresh();
    scene.duration(getDuration());
}

function refreshScenes() {
    scenes.forEach(refreshScene);
}


$window.on('fc:flexleaderboardRendered fc:article-content:resize fc:adsheightchanged',
    refreshScenes);

if (screenSize.getSize() !== 'small') {
    const interval = setInterval(refreshScenes, 1000);
}

export default ($selector) => {
    if (screenSize.getSize() !== 'small') {
        let $rightRailContainer;
        let $articleContent;
        let $sidebar;
        let $headerAd;
        let $rightRailSpacer;
        if ($selector) {
            $rightRailContainer = $selector.find('.sticky-right-rail-container');
            $articleContent = $selector.find('.article-content');
            $sidebar = $selector.find('.article-sidebar');
            $headerAd = $selector.find('.ad-wrapper-large.ad-wrapper-header');
            $rightRailSpacer = $selector.find('.right-rail-spacer');
        } else {
            $rightRailContainer = $('.sticky-right-rail-container');
            $articleContent = $('.article-content');
            $sidebar = $('.article-sidebar');
            $headerAd = $('.ad-wrapper-large.ad-wrapper-header');
            $rightRailSpacer = $('.right-rail-spacer');
        }

        function getDuration() {
            const articleContentHeight = $articleContent.height();
            let height = $headerAd.height();
            if (height < 615) {
                height = 615;
            }
            $rightRailSpacer.css({height: `${height - 195}px`});
            const sideBarOffset = (580 + $rightRailSpacer.outerHeight());
            let duration = articleContentHeight - sideBarOffset;
            if (duration < 0) {
                return 1;
            }
            return duration - 60;
        }

        let currDuration = getDuration();


        if (currDuration < 100) {
            $rightRailContainer.remove();
            return false;
        }
        const scene = new ScrollMagic.Scene({
            triggerElement: $rightRailContainer[0],
            offset: 0,
            duration: getDuration(),
            triggerHook: .14
        })
            .setPin($rightRailContainer[0])
            // .addIndicators({name: `1 (duration: ${getDuration()})`}) // add indicators (requires plugin)
            .addTo(controller);

        scenes.push({
            getDuration,
            scene
        });

        setTimeout(function refreshAllScenesAfter() {
            refreshScenes();
        }, 1000);
    }
};

